export default {"src":"/login-app/[GIT_HASH]/_next/static/media/insights.2d2d4a56.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};